import { useEraseKycIdentityMutation } from '@/domains/workflows/hooks/mutations/useEraseKycIdentityMutation/useEraseKycIdentityMutation';
import { useCurrentCaseQuery } from '@/pages/Entity/hooks/useCurrentCaseQuery/useCurrentCaseQuery';
import { useCallback } from 'react';

const KYC_LIVEKIT_DEDUP_WORKFLOW_ID = 'kyc-livekit-dedup';

export const useEraseKycIdentity = () => {
  const { data: workflow } = useCurrentCaseQuery();
  const { mutate, isLoading: isErasingKycIdentity } = useEraseKycIdentityMutation();

  // Admin-only is enforced by the API; the session carries no roles to check here.
  const isCanEraseKycIdentity = workflow?.workflowDefinition?.id === KYC_LIVEKIT_DEDUP_WORKFLOW_ID;

  const eraseKycIdentity = useCallback(() => {
    if (!workflow?.id) {
      return;
    }

    mutate({ workflowId: workflow.id });
  }, [mutate, workflow?.id]);

  return { isCanEraseKycIdentity, isErasingKycIdentity, eraseKycIdentity };
};
